import z from 'zod';

export const ThirdPartyCredentialsSchema = z.object({
  sharepoint: z
    .object({
      tenantId: z.string(),
      clientId: z.string(),
      clientSecret: z.string(),
      siteId: z.string(),
    })
    .optional(),
  emailStudio: z
    .object({
      tenantId: z.uuid(),
      clientId: z.string(),
      clientSecret: z.string(),
    })
    .partial()
    .optional(),
});

export const ThirdPartySettings = z.object({
  sharepoint: z
    .object({
      filterByCAOField: z.string().optional(),
      // * When true, all document libraries on the site are traversed instead of only the default drive.
      // * Set directly in MongoDB per company — currently used for Longfonds only.
      scanAllDrives: z.boolean().optional(),
    })
    .optional(),
});
